import React, { useEffect, useState } from "react";
import fireIcon from "../../../assets/images/icons/cardIcons/fireIcon.svg";
import addIcon from "../../../assets/images/icons/addIcon.png";
import safeguardingIcon from "../../../assets/images/icons/cardIcons/safeguarding.svg";

import "./NewIncident.css";
import IncidentCard from "../IncidentCard/IncidentCard";

import { useGetIncidentGroupsQuery } from "../../../features/Incidents/IncidentSlice";
import { Loader } from "../../common/Loader/Loader";
import { useLocation, useNavigate } from "react-router";
import toast, { Toaster } from "react-hot-toast";

const NewIncident = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const incidentRelation = queryParams.get("incidentRelation");
  const [isFormCompleted, setIsFormCompleted] = useState(false);
  const [incidentGroupsData, setIncidentGroupsData] = useState([]);

  const {
    data: incidentGroups,
    isLoading: incidentGroupsIsLoading,
    isSuccess: incidentGroupsIsSuccess,
    error: incidentGroupError,
  } = useGetIncidentGroupsQuery();

  useEffect(() => {
    if (incidentGroups) {
      const data = incidentGroups.ids.map((id) => {
        return incidentGroups.entities[id];
      });
      setIncidentGroupsData(data);
    }
    if (incidentGroupError) {
      toast.error(
        `Failed to fetch incident groups: ${
          incidentGroupError?.data?.Message || incidentGroupError?.data?.title
        }`
      );
    }
  }, [incidentGroups, incidentGroupError]);

  useEffect(() => {
    if (isFormCompleted) {
      setIsFormCompleted((prev) => !prev);
    }
  }, [isFormCompleted]);

  const handleNewIncident = () => {
    localStorage.removeItem("fromIncidentId");
    navigate("/incidents/new");
  };

  return (
    <div className="new-incident">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#0b463d",
            color: "#ffffff",
          },
          success: {
            iconTheme: {
              secondary: "#ffffff",
            },
          },
        }}
      />
      <div className="row justify-content-between">
        <div className="col-auto">
          <h4 className="p-2">
            {`${
              incidentRelation === "related"
                ? "Related"
                : incidentRelation === "linked"
                ? "Linked"
                : "New"
            } `}
            Incident
          </h4>
        </div>
        {incidentRelation && (
          <div className="col-auto">
            <button
              className="btn btn-green btn-icon px-5"
              onClick={handleNewIncident}
            >
              <span className="me-2"> New Incident</span>{" "}
              <img src={addIcon} width={22} alt="" />
            </button>
          </div>
        )}
      </div>
      <div className="card custom-card mb-3">
        <div className="card-body">
          <div className="row mb-3">
            <div className="col">
              <div className="card custom-card img-card banner d-flex justify-content-center">
                <div className="container">
                  <div className="card-body custom-card-body">
                    <p className="fs-4">Select the relevant incident type</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {incidentGroupsIsLoading && <Loader />}
          {incidentGroupsIsSuccess && incidentGroupsData.length > 0
            ? incidentGroupsData.map((group) => (
                <div key={group.id} className="row gap-2 mb-2">
                  <IncidentCard
                    image={group.id === 1 ? fireIcon : safeguardingIcon}
                    title={group.description}
                    types={group?.types}
                    incidentGroupId={group.id}
                  />
                </div>
              ))
            : ""}
        </div>
      </div>
    </div>
  );
};

export default NewIncident;
